import { useDisclosure, MenuItem, MenuDivider } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { ExternalRegionLinkButton } from '@acp/feature/auth';
import { faUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import { FaIcon } from '@acp/core-ui';
import { OccupantActions } from '../../../../components/buttons';
import { AccessIssueWizardResolveButton } from '../wizard/resolve-button';

export function ResolveActionButton({
    propertyId,
    tenancyId = null,
    hideDropDown = false,
    variant = 'outline',
}: {
    propertyId: number;
    tenancyId?: number | null;
    variant?: string;
    hideDropDown?: boolean;
}) {
    const resolveModalDisclosure = useDisclosure();

    let actionLink: string | undefined | null;

    const onResolveButtonClicked = () => {
        if (actionLink == null) {
            resolveModalDisclosure.onOpen();
        }
    };

    return (
        <OccupantActions
            as={actionLink != null ? ExternalRegionLinkButton : undefined}
            path={actionLink}
            propertyId={propertyId}
            tenancyId={tenancyId}
            title="Resolve issue"
            isDisabled={false}
            onClick={onResolveButtonClicked}
            hideDropDown={hideDropDown}
            variant={variant}
            isCustomMenuItems
            useAccessIssueWizard
        >
            <AccessIssueWizardResolveButton propertyId={propertyId} isMenuItem />
            <MenuDivider />

            <MenuItem as={Link} to={`/property/${propertyId}`} target="blank">
                View property
                <FaIcon icon={faUpRightFromSquare} ml={2} h={3} />
            </MenuItem>
        </OccupantActions>
    );
}
